import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function Footer() {
  return (
    <footer className="bg-background-900 text-foreground-200">
      <div className="px-4 md:px-6 lg:px-10 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
            <div className="md:col-span-1">
              <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer">
                <span className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-vip-crown-line text-xl text-primary-400"></i>
                </span>
                <span className="text-lg font-heading font-semibold text-white whitespace-nowrap">
                  女王调教指南
                </span>
              </Link>
              <p className="text-sm text-foreground-400 leading-relaxed">
                专业、安全、知情的女王调教关系指导平台，帮助成年人建立健康的支配与臣服关系。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-heading font-semibold text-white mb-4">
                内容分类
              </h4>
              <ul className="flex flex-col gap-2">
                {categories.map((cat) => (
                  <li key={cat.id}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-foreground-400 hover:text-white transition-colors whitespace-nowrap cursor-pointer"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-heading font-semibold text-white mb-4">
                快速链接
              </h4>
              <ul className="flex flex-col gap-2">
                <li>
                  <Link
                    to="/"
                    className="text-sm text-foreground-400 hover:text-white transition-colors whitespace-nowrap cursor-pointer"
                  >
                    首页
                  </Link>
                </li>
                <li>
                  <Link
                    to="/about"
                    className="text-sm text-foreground-400 hover:text-white transition-colors whitespace-nowrap cursor-pointer"
                  >
                    关于我们
                  </Link>
                </li>
                <li>
                  <Link
                    to="/category/queen-domination-basics"
                    className="text-sm text-foreground-400 hover:text-white transition-colors whitespace-nowrap cursor-pointer"
                  >
                    女王调教入门
                  </Link>
                </li>
                <li>
                  <Link
                    to="/category/safety-rules-boundaries"
                    className="text-sm text-foreground-400 hover:text-white transition-colors whitespace-nowrap cursor-pointer"
                  >
                    安全规范与边界
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-heading font-semibold text-white mb-4">
                声明
              </h4>
              <p className="text-sm text-foreground-400 leading-relaxed">
                本网站内容仅供成年人参考学习，所有内容均基于知情同意和安全规范原则。我们倡导健康、互相尊重的成人关系。
              </p>
            </div>
          </div>

          <div className="border-t border-foreground-700/30 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-foreground-500">
              &copy; {new Date().getFullYear()} 女王调教指南 - 专业支配关系指导平台。保留所有权利。
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-foreground-500 hover:text-white transition-colors whitespace-nowrap">
                隐私政策
              </a>
              <a href="#" className="text-xs text-foreground-500 hover:text-white transition-colors whitespace-nowrap">
                使用条款
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}